<template>
    <card :class="textClass">
        <el-progress
            type="dashboard"
            :percentage="percentage"
            :color="colors"
            stroke-linecap="butt"
            :format="format"
            :class="{ 'u-small-caps': label, 'progress-card__diagram': true }"
        />

        <div class="progress-card__text">
            <i v-if="icon" :class="icon" />
            <p v-else-if="text" class="m-0 u-small-caps">{{ text }}</p>
        </div>
    </card>
</template>

<script>
import Card from '@/components/Card'

const PERCENTAGE_ERROR = 55
const PERCENTAGE_WARNING = 70
const PERCENTAGE_SUCCESS = 100

export default {
    name: 'ProgressCard',

    components: { Card },

    props: {
        percentage: { type: Number, required: true },
        label: { type: String, default: '' },
        text: { type: String, default: '' },
        icon: { type: String, default: '' },
    },

    computed: {
        colors () {
            return [
                { color: '#fe413c', percentage: PERCENTAGE_ERROR },
                { color: '#e6a23c', percentage: PERCENTAGE_WARNING },
                { color: '#5cb87a', percentage: PERCENTAGE_SUCCESS },
            ]
        },

        format () {
            const label = this.label

            return (percentage) => label || percentage
        },

        textClass () {
            if (this.percentage < PERCENTAGE_ERROR) {
                return 'progress-card--error'
            } else if (this.percentage < PERCENTAGE_WARNING) {
                return 'progress-card--warning'
            }

            return 'progress-card--success'
        },
    },
}
</script>

<style lang="scss" scoped>
$progress-error-color: #fe413c;
$progress-warning-color: #e6a23c;
$progress-success-color: #5cb87a;

.progress-card {
    &--error {
        color: $progress-error-color;
    }

    &--warning {
        color: $progress-warning-color;
    }

    &--success {
        color: $progress-success-color;
    }

    &__text {
        text-align: center;
    }

    &__diagram /deep/ .el-progress__text {
        font-size: $font-size-20 !important;
        color: rgba($white, 0.7) !important;
    }
}
</style>
